export const FOTO = {
  src: "/images/endos.png",
  alt: {
    id: "Poster layanan Endoskopi Urologi RS Jakarta Medical Center.",
    en: "Urological endoscopy service poster of Jakarta Medical Center Hospital.",
  },
};
export const ENDOSKOPI = {
  telepon: [
    {
      label: { id: "Customer Service", en: "Customer Service" },
      tampil: "0811-901-874",
      tel: "+62811901874",
      wa: "62811901874",
      pesanWa: {
        id: "Halo RS Jakarta Medical Center,\n\nSaya ingin melakukan reservasi konsultasi di poliklinik urologi.\n\nMohon informasi jadwal dokter dan ketentuannya. Terima kasih.",
        en: "Hello RS Jakarta Medical Center,\n\nI would like to book a consultation at the urology clinic.\n\nPlease let me know the doctor's schedule and requirements. Thank you.",
      },
      utama: true,
    },
    {
      label: { id: "Hunting", en: "Main line" },
      tampil: "(021) 798 0888",
      tel: "+62217980888",
      utama: false,
    },
  ],
};
export const KETENTUAN = [];
export const LANGKAH = [
  {
    judul: { id: "Konsultasi urologi", en: "Urology consultation" },
    isi: {
      id: "Hubungi Customer Service untuk menjadwalkan pemeriksaan dengan dokter urologi.",
      en: "Contact Customer Service to schedule an examination with a urologist.",
    },
  },
  {
    judul: { id: "Pemeriksaan awal", en: "Initial examination" },
    isi: {
      id: "Dokter memeriksa keluhan Anda dan menentukan apakah tindakan endoskopi diperlukan.",
      en: "The doctor will examine your symptoms and determine whether an endoscopy is needed.",
    },
  },
  {
    judul: { id: "Penjadwalan tindakan", en: "Scheduling the procedure" },
    isi: {
      id: "Apabila diperlukan, dokter menjelaskan persiapannya dan menjadwalkan tindakan.",
      en: "If needed, the doctor will explain the preparation required and schedule the procedure.",
    },
  },
];
